module.exports = __webpack_public_path__ + "static/media/Denied.fb5888a4.svg";